export default Object.freeze({
  optionelectronicsignature: "eduesp.pei.optionelectronicsignature",
  optiondigitalsignature: "eduesp.pei.optiondigitalsignature"
});
